import { render, staticRenderFns } from "./reportDetails.vue?vue&type=template&id=f9992646&scoped=true&"
import script from "./reportDetails.vue?vue&type=script&lang=js&"
export * from "./reportDetails.vue?vue&type=script&lang=js&"
import style0 from "./reportDetails.vue?vue&type=style&index=0&id=f9992646&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9992646",
  null
  
)

export default component.exports